import { Component, ElementRef, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { select } from '@angular-redux/store';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
import { BaseComponent } from '@ridango/core';
@Component({
    selector: 'gl-cart-end-warning-modal',
    templateUrl: './cart-end-warning-modal.component.html',
    styleUrls: ['./cart-end-warning-modal.component.scss']
})
export class CartEndWarningModalComponent extends BaseComponent implements OnInit, OnDestroy {
    @ViewChild('focus') focusEl: ElementRef;

    @select(['cart', 'countdownTimer']) timeLeft$;

    showWarningDialog = false;
    constructor(
        private router: Router,
        private translate: TranslateService
    ) {
        super();
    }

    ngOnInit() {
        this.timeLeft$.pipe(takeUntil(this.componentDestroyed$)).subscribe((timer) => {
            if (timer <= 1) {
                this.showWarningDialog = false;
            }
            if (timer === 120) {
                this.showWarningDialog = true;
                setTimeout(() => this.focusEl.nativeElement.focus());
            }
        });
    }

    goToCart() {
        this.showWarningDialog = false;
        this.router.navigate([this.translate.currentLang, 'purchase', 'cart']);
    }

    closeDialog() {
        this.showWarningDialog = false;
    }
}
